export default "__VITE_ASSET__DoDSDmjz__"